import React from 'react';

import { ContainerWithMaxWidth } from '@/core/components/ContainerWithMaxWidth';
import type { BannerSlot } from '@/core/lib/ads/ads.context';

interface PublicLayoutProps extends React.PropsWithChildren {
  adSlot?: BannerSlot;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => (
  <main id="app" className="w-full flex-col pt-space-header">
    <ContainerWithMaxWidth>
      <div className="grid w-full grid-cols-2 gap-4 md:grid-cols-8 md:gap-5 lg:grid-cols-12 lg:gap-6">
        <div className="col-span-2 md:col-span-8 lg:col-span-8">{children}</div>
        <div className="col-span-4 hidden justify-end lg:flex lg:pb-6">
          <div className="sticky right-0 top-[84px] size-fit">
            <div className="min-h-[620px] w-[320px]" dangerouslySetInnerHTML={{ __html: `<div class="HalfpageAd_1" style="display:none;"></div>` }}></div>
          </div>
        </div>
      </div>
    </ContainerWithMaxWidth>
  </main>
);

export default PublicLayout;
